import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileConflictDeclarations from '../../../../../common/AdviserProfiles/AdviserProfileConflictDeclarations'
import * as styles from './_PendingApprovalAdviserProfileConflictDeclarationsEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import {
  startEditingDeclarations
  , stopEditingDeclarations
  , cancelEditingDeclarations
  , fetchConflictDeclarations
  , conflictDeclarationSelectedChanged
  , actions
} from './pendingApprovalAdviserProfileConflictDeclarationsEditorActions'
import PropTypes from 'prop-types';

class pendingApprovalAdviserProfileConflictDeclarationsEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingDeclarations: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingDeclarations: PropTypes.func.isRequired,
    stopEditingDeclarations: PropTypes.func.isRequired,
    cancelEditingDeclarations: PropTypes.func.isRequired,
    fetchConflictDeclarations: PropTypes.func.isRequired,
    allDeclarations: PropTypes.array.isRequired,
    conflictDeclarationSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    oldProfile: PropTypes.object,
    conflictDeclarationsModifications: PropTypes.array.isRequired,
    noConflict: PropTypes.func.isRequired
  };

  componentDidMount () {
    this.props.fetchConflictDeclarations()
  }

  constructor (props) {
    super(props)
    this.stopEditingConflictDeclarations = this.stopEditingConflictDeclarations.bind(this)
    this.state = {
      checkedItems: new Map(),
      checkedNoConflictItems: new Map(),
      isNoConflictChecked: false,
      isConflictChecked: false,
      copyOfDeclarations: []
    }
  }

  handleNoConflictChange (e) {
    const item = e.target.value
    const isNoConflictChecked = e.target.checked
    if (isNoConflictChecked) {
      this.props.noConflict()
      this.state.checkedNoConflictItems.set(item, isNoConflictChecked)
      this.setState({isNoConflictChecked: isNoConflictChecked})
      this.setState({
        state: this.state
      })
    } else {
      this.state.checkedNoConflictItems.delete(item)
      this.setState({isNoConflictChecked: isNoConflictChecked})
    }
  }

  handleOnConflictChanged (e) {
    const item = e.target.value
    const isConflictChecked = e.target.checked
    if (isConflictChecked) {
      this.state.checkedItems.set(item, isConflictChecked)
      this.setState({isNoConflictChecked: !isConflictChecked})
    } else {
      this.state.checkedItems.delete(item)
      this.setState({isNoConflictChecked: isConflictChecked})
    }
  }

  stopEditingConflictDeclarations () {
    this.props.stopEditingDeclarations()
  }

  render () {
    const editingDeclarations = this.props.editingDeclarations
    const selectedDeclarations = this.props.profile.conflictDeclarations || []

    if (editingDeclarations) {
  const allDeclarations = this.props.allDeclarations.map(
    conflictDeclaration => ({
      ...conflictDeclaration,
      selected: selectedDeclarations.some(
        selectedDeclaration =>
          selectedDeclaration.conflictDeclarationId ===
          conflictDeclaration.conflictDeclarationId
      )
    })
  )

  return (
    <div className={styles['form-bottom-margin']}>
      <h4 className={styles['title']}>
        Conflict Declarations
      </h4>

      <p>
        Please indicate if any of the following potential
        conflicts of interest apply to you and/or your
        business. Your selections will be displayed on
        your Allan Gray profile.
      </p>

      <form>
        {allDeclarations.map(conflictDeclaration => (
          <FormCheck
            key={
              conflictDeclaration.conflictDeclarationId
            }
            type="checkbox"
            checked={
              conflictDeclaration.selected &&
              this.state.isNoConflictChecked === false
            }
            value={
              conflictDeclaration.conflictDeclarationId
            }
            onChange={e => {
              this.props.conflictDeclarationSelectedChanged(
                conflictDeclaration
              )
              this.handleOnConflictChanged(e)
            }}
            label={conflictDeclaration.description}
          />
        ))}

        <FormCheck
          key={99}
          type="checkbox"
          checked={
            selectedDeclarations.length === 0 ||
            this.state.isNoConflictChecked === true
          }
          onChange={e => {
            this.handleNoConflictChange(e)
          }}
          label="None of the above apply to me or my business"
        />
      </form>
    </div>
  )
}

    return <div>
      <AdviserProfileConflictDeclarations conflictDeclarations={this.props.conflictDeclarationsModifications} comparison />
    </div>
  }
}

const mapStateToProps = (state) => {
  return {
    editingDeclarations: state.adviserProfileApprovalEditorContainer.conflictDeclarations.editingDeclarations,
    loading: state.adviserProfileApprovalEditorContainer.conflictDeclarations.loadingDeclarations,
    formIsValid: state.adviserProfileApprovalEditorContainer.conflictDeclarations.isInvalid.formIsValid,
    validationstate: state.adviserProfileApprovalEditorContainer.conflictDeclarations.isInvalid,
    submitting: state.adviserProfileApprovalEditorContainer.conflictDeclarations.submitting,
    allDeclarations: state.adviserProfileApprovalEditorContainer.conflictDeclarations.allDeclarations,
    conflictDeclarationsModifications: state.adviserProfileApprovalEditorContainer.conflictDeclarations.conflictDeclarationsModifications
  }
}

const mapDispatchToProps = (dispatch) => {
  const { set } = actions
  return bindActionCreators({
    startEditingDeclarations: startEditingDeclarations,
    stopEditingDeclarations: stopEditingDeclarations,
    cancelEditingDeclarations: cancelEditingDeclarations,
    fetchConflictDeclarations: fetchConflictDeclarations,
    conflictDeclarationSelectedChanged: conflictDeclarationSelectedChanged,
    noConflict: set.noConflict
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (pendingApprovalAdviserProfileConflictDeclarationsEditorActions))
